"use client";

import * as React from "react";
import { useEffect, useState } from "react";
import { ThemeProvider as NextThemesProvider } from "@solorev/react-themes";
import { type ThemeProviderProps } from "@solorev/react-themes";
import { usePathname } from "next/navigation";
import { forcedThemeRules } from "./forcedThemeRules";
export function ThemeProvider({
  children,
  ...props
}: ThemeProviderProps) {
  const [forcedTheme, setForcedTheme] = useState<string | undefined>(undefined);
  const pathname = usePathname();
  useEffect(() => {
    setForcedTheme(forcedThemeRules(pathname));
  }, [pathname]);
  return <NextThemesProvider attribute="class" storageKey="theme" enableSystem themes={["light", "dark", "system"]} defaultTheme="system" forcedTheme={forcedTheme} {...props} data-sentry-element="NextThemesProvider" data-sentry-component="ThemeProvider" data-sentry-source-file="index.tsx">
      {children}
    </NextThemesProvider>;
}